import { render, staticRenderFns } from "./ChartFeedback.vue?vue&type=template&id=75a794bd&"
import script from "./ChartFeedback.vue?vue&type=script&lang=js&"
export * from "./ChartFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports